import { GAME_EVENTS } from '@kulee/tga-constant'
import BaseModule from './BaseModule'
import logger from './logger'
import type { Callback } from './types'

class Wallet extends BaseModule {
  /**
   * 支付
   * @param options 支付参数
   */
  public pay(options: PayOptions): void {
    const { goodsInfo, callback } = options

    logger.info('ready to pay goods', goodsInfo)
    this.pm.removeAll(GAME_EVENTS.PAY_ORDER_RESULT)
    this.pm.on(GAME_EVENTS.PAY_ORDER_RESULT, ({ data }) => {
      callback(data)
    })

    this.pm.emit(GAME_EVENTS.PAY_ORDER, {
      goodsInfo
    })
  }
}

type PayOptions = {
  goodsInfo: GoodsInfo
  callback: Callback
}

type GoodsInfo = {
  // 金额
  amount: number
  // 应用ID
  appId: string
  // 回调地址 选填
  callbackUrl?: string
  // 支付币种代码
  currencyCode: string
  // 描述
  description: number
  // 附加支付参数JSON，谷歌支付传sku
  externalParam?: string
  // 订单详情json
  orderDetail: string
  // 订单编号
  orderNo: string
}

export default Wallet
